<div [formGroup]="dateForm">
    <div class="row">
        <div class="column column-2">
            <vega-control-group for="startDateCtrl" label="{{ 'OVERVIEW.STARTDATE' | translate }}" [required]="true">
                <input formControlName="startDateCtrl" #startDateControl dateFormat="L" vegaDatepicker type="text" />
            </vega-control-group>
        </div>
        <div class="column column-2">
            <vega-control-group for="endDateCtrl" label="{{ 'OVERVIEW.ENDDATE' | translate }}" [required]="true">
                <input formControlName="endDateCtrl" #endDateControl dateFormat="L" vegaDatepicker type="text" />
            </vega-control-group>
        </div>
        <div class="column column-1">
            <input
                (click)="onSearch()"
                type="submit"
                value="{{ 'OVERVIEW.SEARCH' | translate }}"
                class="search_btn btn" />
        </div>
        @if (hasMore$ | async) {
            <div class="column column-1">
                @if (lastPayoutId$ | async; as lastPayoutId) {
                    <input
                        (click)="onLoadMore(lastPayoutId)"
                        type="submit"
                        value="{{ 'OVERVIEW.LOADMORE' | translate }}"
                        class="search_btn btn" />
                }
            </div>
        }
        @if (hasMore$ | async) {
            <p class="column column-3">
                {{ "OVERVIEW.LOADMORE_INFO" | translate }}
            </p>
        }
    </div>
</div>
<vega-igx-grid
    gridId="transaction-grid"
    [columns]="overviewColumns"
    [primaryKey]="'BalanceTransactionId'"
    [data]="viewModel$ | async"
    [isLoading]="isLoading$ | async"
    selectionMode="none">
    <ng-template vegaIgxColumnTemplate [fields]="['customerId']" let-val let-cell="cell">
        @if (bridgeActive) {
            <button class="btn link" type="button" (click)="onSelectCustomer(cell.row.data)">
                {{ val }}
            </button>
        }
        @if (!bridgeActive) {
            <span>{{ val }}</span>
        }
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['orderId']" let-val let-cell="cell">
        @if (bridgeActive) {
            <button class="btn link" type="button" (click)="onSelectOrder(cell.row.data)">
                {{ val }}
            </button>
        }
        @if (!bridgeActive) {
            <span>{{ val }}</span>
        }
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['invoiceId']" let-val let-cell="cell">
        @if (bridgeActive) {
            <button class="btn link" type="button" (click)="onSelectInvoice(cell.row.data)">
                {{ val }}
            </button>
        }
        @if (!bridgeActive) {
            <span>{{ val }}</span>
        }
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['chargeCreateDate']" let-val let-cell="cell">
        {{ val | vegaDate: undefined : "UTC" }}
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['chargeAmount']" let-val let-cell="cell">
        <span [ngClass]="getChargeAmountClass(cell.row.data.chargeAmount)">
            {{ val | price: cell.row.data.chargeCurrency }}
        </span>
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['transactionType']" let-val let-cell="cell">
        <span [ngClass]="getTransactionTypeClass(cell.row.data.transactionType)">
            @switch (cell.row.data.transactionType) {
                @case ("charge") {
                    {{ "OVERVIEW.TRANSACTION_TYPE_CHARGE" | translate }}
                }
                @case ("refund") {
                    {{ "OVERVIEW.TRANSACTION_TYPE_REFUND" | translate }}
                }
                @case ("stripe_fee") {
                    {{ "OVERVIEW.TRANSACTION_TYPE_FEE" | translate }}
                }
                @case ("network_cost") {
                    {{ "OVERVIEW.TRANSACTION_TYPE_NETWORK_COST" | translate }}
                }
            }
        </span>
    </ng-template>
    <ng-template vegaIgxColumnTemplate [fields]="['payoutAmount']" let-val let-cell="cell">
        {{ val | price: cell.row.data.payoutCurrency }}
    </ng-template>
</vega-igx-grid>
